/**
 * FAQ accordion (TZ section 7): the first item is open by default (markup), opening another one closes the current
 * (+ ↔ −, smooth height via CSS grid rows). Clicking the open item closes it. All breakpoints.
 */
export const faq = () => {
    return new Promise((resolve) => {
        document.querySelectorAll('.faq__list').forEach((list) => init(list));
        resolve();
    });
};

const init = (list) => {
    const items = [...list.querySelectorAll('.faq__item')];

    const toggle = (item, open) => {
        item.classList.toggle('is-open', open);
        item.querySelector('.faq__question')?.setAttribute('aria-expanded', open ? 'true' : 'false');
    };

    items.forEach((item) => {
        item.querySelector('.faq__question')?.addEventListener('click', () => {
            const open = !item.classList.contains('is-open');
            items.forEach((other) => {
                if (other !== item) toggle(other, false);
            });
            toggle(item, open);
        });
    });
};
